// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\PaymentResponse

import { PaymentStatus, PaymentMethod, PaymentPosMethod } from './enums.gen';
import { hydrateCustomer, type Customer, type CustomerApiResponse } from './customer.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type PaymentApiResponse = {
	id: string;
	amount: number;
	bookingAmount: number;
	bookingAmountRefunded: number;
	amountRefunded: number;
	value: number;
	fee: number;
	net: number;
	splitFee: number;
	ownerSplitFee: number;
	status: PaymentStatus;
	method: PaymentMethod;
	posMethod: PaymentPosMethod | null;
	createdAt: string;
	updatedAt: string;
	bookingId: string | null;
	bookingDate: string | null;
	parentPaymentId: string | null;
	parentPayment: PaymentApiResponse | null;
	objectId: string | null;
	errorCode: string | null;
	customer: CustomerApiResponse | null;
};

export type Payment = {
	id: string;
	amount: number;
	bookingAmount: number;
	bookingAmountRefunded: number;
	amountRefunded: number;
	value: number;
	fee: number;
	net: number;
	splitFee: number;
	ownerSplitFee: number;
	status: PaymentStatus;
	method: PaymentMethod;
	posMethod: PaymentPosMethod | null;
	createdAt: DateTime;
	updatedAt: DateTime;
	bookingId: string | null;
	bookingDate: DateTime | null;
	parentPaymentId: string | null;
	parentPayment: Payment | null;
	objectId: string | null;
	errorCode: string | null;
	customer: Customer | null;
};

export function hydratePayment(data: PaymentApiResponse): Payment {
	return {
		...data,
		createdAt: DateTimefromISO(data.createdAt)!,
		updatedAt: DateTimefromISO(data.updatedAt)!,
		bookingDate: DateTimefromISO(data.bookingDate),
		parentPayment: data.parentPayment ? hydratePayment(data.parentPayment) : null,
		customer: data.customer ? hydrateCustomer(data.customer) : null,
	};
}